import { Simulation } from 'src/app/core/models/simulation.model';
import { Color } from 'three';
import { Catenary3D } from '../../catenary-answer';
import ObjectBuilder from '../object-builders/object-builder.model';

export default abstract class GraphicProperties {
  protected _object: any;

  protected get object(): any {
    return this._object;
  }

  protected set object(object: any) {
    this._object = object;
  }

  show(): void {
    this.object.visible = true;
  }

  hide(): void {
    this.object.visible = false;
  }

  delete(): void {
    if (!this.object) {
      return;
    }
    this.object.material?.dispose();
    this.object.geometry?.dispose();
    this.object.removeFromParent();
  }

  abstract updateColor(color: Color): void;
  abstract build(riser: Catenary3D, simulation: Simulation, object: any): Promise<any>;
  abstract getBuilder(): ObjectBuilder;
}
